import COMPONENT_DATA from './components/content.js';

(async function () {
  let component_name = ('componentName' in document.currentScript.dataset?document.currentScript.dataset['componentName']:'dsb-content');
  let _url = document.currentScript?.src;
  let url=_url.split("/").slice(0, -1).join("/") || "";

  try
  {
    let script_blocking_import = ('blocking_import' in document.currentScript.dataset?document.currentScript.dataset['blocking_import']:'');
    if(script_blocking_import)
    {
      script_blocking_import = JSON.parse(script_blocking_import.replaceAll("'",'"'));
      if(Array.isArray(script_blocking_import) && script_blocking_import.length>0 && url.length>0)
      {
        COMPONENT_DATA.prototype._initImportBlockingHelpers= async function(dsb)
        {
          for(let i=0;i<script_blocking_import.length;i++)
          {
            let fetch_response = await fetch(url+'/'+script_blocking_import[i],{'method':'GET'});
            if(typeof fetch_response === 'object' && 'status' in fetch_response)
            {
              if(fetch_response.status=='200')
              {
                let fetch_data = await fetch_response.text();
                fetch_data=fetch_data.trim();
                // Expect: export default function(_HELPERS,_FILTERS={}){ ... }
                const match = fetch_data.match(/^export\s+default\s+(function\s*\([^)]*\)\s*\{[\s\S]*\})$/);
                if (!match) throw new Error("Unsupported code format for default export.");

                const fnSource = match[1]; // "function(...) { ... }"

                // Create a new function that returns that function object.
                // No eval: we never eval arbitrary statements—only construct from a function literal.
                const wrapper = new Function(`return (${fnSource});`);
                const wrapper_runnable = wrapper();
                wrapper_runnable(dsb.helpers,dsb.filters,dsb.hooks,dsb.events);
              }
            }
          }
        }
      }
    }

    let script_import = ('import' in document.currentScript.dataset?document.currentScript.dataset['import']:'');
    if(script_import)
    {
      script_import = JSON.parse(script_import.replaceAll("'",'"'));
      if(Array.isArray(script_import) && script_import.length>0 && url.length>0)
      {
        COMPONENT_DATA.prototype._initImportHelpers= async function(dsb)
        {
          for(let i=0;i<script_import.length;i++)
          {
            let fetch_response = await fetch(url+'/'+script_import[i],{'method':'GET'});
            if(typeof fetch_response === 'object' && 'status' in fetch_response)
            {
              if(fetch_response.status=='200')
              {
                let fetch_data = await fetch_response.text();

                fetch_data=fetch_data.trim();
                // Expect: export default function(_HELPERS,_FILTERS={}){ ... }
                const match = fetch_data.match(/^export\s+default\s+(function\s*\([^)]*\)\s*\{[\s\S]*\})\s*;?$/);
                if (!match) throw new Error("Unsupported code format for default export.");

                const fnSource = match[1]; // "function(...) { ... }"

                // Create a new function that returns that function object.
                // No eval: we never eval arbitrary statements—only construct from a function literal.
                const wrapper = new Function(`return (${fnSource});`);
                const wrapper_runnable = wrapper();
                wrapper_runnable(dsb.helpers,dsb.filters,dsb.hooks,dsb.events);
              }
            }
          }
        }
      }
    }
  }
  catch(ex)
  {
    console.error('Loading... '+_url+', failed', ex);
  }

  customElements.define(
    component_name,
    COMPONENT_DATA
  );
})();
